/**
 * Pool module definition — content fetch is available on every website, so
 * the module is always enabled.
 */

import type { SdkModuleDefinition } from '../types';
import { createPoolModuleApi, type PoolModuleApi } from './api';

export const poolModule: SdkModuleDefinition<PoolModuleApi> = {
  id: 'pool',
  isEnabled: () => true,
  install: (ctx) => createPoolModuleApi(ctx),
};
